import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  fetchAlertSettings,
  type SensorAlertCategory,
} from '../queries/sensorAlertSettings.queries'
import {
  updateAlertSettings,
  type UpdateAlertSettingsPayload,
} from '../mutations/sensorAlertSettings.mutations'

export const useAlertSettings = () =>
  useQuery({
    queryKey: ['alertSettings'],
    queryFn: fetchAlertSettings,
  })

export const useUpdateAlertSettings = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      category,
      data,
    }: {
      category: SensorAlertCategory
      data: UpdateAlertSettingsPayload
    }) => updateAlertSettings(category, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['alertSettings'] })
    },
  })
}
